import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Divider } from "@gemini/ui";
import { ContactInfos } from "../ContactInfos";
import { CreateOrUpdateProfile } from "./SeekerProfile";
import { LoginBox } from "./LoginBox";
import { useAuthContext } from "@/contexts/auth";
export const ContactFormEnrichment = ({ contactCard, testId }) => {
    const { validToken } = useAuthContext();
    return (_jsxs(_Fragment, { children: [_jsx(Divider, { marginBottom: "spacing.24", "aria-hidden": "true" }), _jsx(ContactInfos, { isPhysicalPerson: contactCard.isPrivateOwner, testId: `${testId}.ContactInfos`, title: contactCard.title, subtitle: contactCard.subtitle, logoUrl: contactCard.logoUrl }), _jsx(Divider, { marginVertical: "spacing.24", "aria-hidden": "true" }), _jsx(CreateOrUpdateProfile, {}), !validToken && _jsx(LoginBox, {})] }));
};
